export function trouverElementFrere(elementEtParent, direction, distance, rapport) {
    var elementFrere = null;
    switch(elementEtParent.parent?.type) {
        case 'SECTION':
            elementFrere = trouverElementFrereDansSection(elementEtParent.parent, elementEtParent.element, direction, distance);
            break;
        case 'ZONE':
            elementFrere = trouverElementFrereDansZone(elementEtParent.parent, elementEtParent.element, direction, distance);
            break;
        case 'TABLEAU':
            elementFrere = trouverElementFrereDansTableau(elementEtParent.parent, elementEtParent.element, direction, distance);
            break;
        case 'GRAPHIQUE':
            elementFrere = trouverElementFrereDansGraphique(elementEtParent.parent, elementEtParent.element, direction, distance);
            break;
    }
    if (elementFrere != null) {
        const elementEtParentFrere = {element: elementFrere, parent: elementEtParent.parent};
        if (elementFrere.masque && !rapport.affichageElementsMasques) {
            if (distance === -1) {
                return trouverElementFrere(elementEtParentFrere, getDirectionOpposee(direction), 1, rapport);
            } else {
                return trouverElementFrere(elementEtParentFrere, direction, 1, rapport);
            }
        } else {
            return elementEtParentFrere;
        }
    } else {
        return null;
    }
}

function trouverElementFrereDansSection(section, element, direction, distance) {
    const positionDansSection = element.positionDansSection;
    let positionDansSectionSup = positionDansSection[positionDansSection.length - 1];
    switch(direction) {
        case 'haut':
            if (element.type === 'TEXTE' && element.positionDansSection === -1) {
                return element;
            } else if (element.type === 'SECTION') {
                if (distance === -1) {
                    return section.titre;
                }
                positionDansSectionSup = section.sousSections.indexOf(element);
                if (positionDansSectionSup - distance >= 0) {
                    return section.sousSections[positionDansSectionSup - distance];
                } else {
                    if (section.elements.length > 0) {
                        const dernierElement = section.elements[section.elements.length - 1];
                        distance -= positionDansSectionSup + 1;
                        return trouverElementFrereDansSection(section, dernierElement, direction, distance);
                    } else {
                        return section.titre;
                    }
                }
            } else {
                if (distance !== -1 && positionDansSectionSup - distance >= 0) {
                    return section.elements[positionDansSectionSup - distance];
                } else {
                    return section.titre;
                }
            }
        case 'gauche':
            return null;
        case 'bas':
            if (element.type === 'TEXTE' && positionDansSection === -1) {
                if (distance === -1) {
                    if (section.sousSections.length > 0) {
                        return section.sousSections[section.sousSections.length - 1];
                    } else if (section.elements.length > 0) {
                        return section.elements[section.elements.length - 1];
                    } else {
                        return element;
                    }
                }
                if (section.elements.length > 0) {
                    return trouverElementFrereDansSection(section, section.elements[0], direction, distance - 1);
                } else if (section.sousSections.length > 0) {
                    return trouverElementFrereDansSection(section, section.sousSections[0], direction, distance - 1);
                } else {
                    return null;
                }
            } else if (element.type === 'SECTION') {
                if (distance === -1) {
                    return section.sousSections[section.sousSections.length - 1];
                }
                positionDansSectionSup = section.sousSections.indexOf(element);
                if (positionDansSectionSup + distance < section.sousSections.length) {
                    return section.sousSections[positionDansSectionSup + distance];
                } else {
                    return section.sousSections[section.sousSections.length - 1];
                }
            } else {
                if (distance === -1) {
                    if (section.sousSections.length) {
                        return section.sousSections[section.sousSections.length - 1];
                    } else if (section.elements.length) {
                        return section.elements[section.elements.length - 1];
                    } else {
                        return section.titre;
                    }
                }
                if (positionDansSectionSup + distance < section.elements.length) {
                    return section.elements[positionDansSectionSup + distance];
                } else if (section.sousSections.length > 0) {
                    distance -= section.elements.length - positionDansSectionSup;
                    if (distance === 0) {
                        return section.sousSections[0];
                    } else {
                        return trouverElementFrereDansSection(section, section.sousSections[0], direction, distance)
                    }
                } else {
                    return null;
                }
            }
        case 'droite':
            return null;
    }
}

function trouverElementFrereDansZone(zone, element, direction, distance) {
    const positionElement = element.positionDansSection;
    const positionDansZone = positionElement[positionElement.length - 1];
    switch(direction) {
        case 'haut':
        case 'gauche':
            if (distance !== -1 && positionDansZone - distance >= 0) {
                return zone.elements[positionDansZone - distance];
            } else {
                return zone.elements[0];
            }
        case 'bas':
        case 'droite':
            if (distance !== -1 && positionDansZone + distance < zone.elements.length) {
                return zone.elements[positionDansZone + distance];
            } else {
                return zone.elements[zone.elements.length - 1];
            }
    }
}

function trouverElementFrereDansTableau(tableau, cellule, direction, distance) {
    const coordCellule = {ligne: cellule.ligne, colonne: cellule.colonne};
    switch(direction) {
        case 'haut':
            if (distance === -1) {
                coordCellule.ligne = 1;
            } else {
                coordCellule.ligne = coordCellule.ligne - distance;
            }
            break;
        case 'droite':
            if (distance === -1) {
                coordCellule.colonne = Math.max(...tableau.cellules.filter(c => c.ligne === cellule.ligne).map(c => c.colonne));
            } else {
                coordCellule.colonne = coordCellule.colonne + Math.max(distance, cellule.largeur);
            }
            break;
        case 'bas':
            if (distance === -1) {
                coordCellule.ligne = Math.max(...tableau.cellules.filter(c => c.colonne === cellule.colonne).map(c => c.ligne));
            } else {
                coordCellule.ligne = coordCellule.ligne + Math.max(distance, cellule.hauteur);
            }
            break;
            case 'gauche':
            if (distance === -1) {
                coordCellule.colonne = 1;
            } else {
                coordCellule.colonne = coordCellule.colonne - distance;
            }
            break;
    }
    return trouverCelluleTableau(tableau, coordCellule);
}

function trouverElementFrereDansGraphique(graphique, cellule, direction, distance) {
    switch(cellule.type) {
        case 'AxePrincipal':
            switch (direction) {
                case 'haut':
                case 'gauche':
                    return null;
                case 'droite':
                    if (graphique.axePrincipal.valeurs.length > 0) {
                        if (distance === -1 || distance - 1 >= graphique.axePrincipal.valeurs.length) {
                            return graphique.axePrincipal.valeurs[graphique.axePrincipal.valeurs.length - 1];
                        } else {
                            return graphique.axePrincipal.valeurs[distance - 1];
                        }
                    } else {
                        return null;
                    }
                case 'bas':
                    if (graphique.series.length > 0) {
                        if (distance === -1 || distance - 1 < graphique.series.length) {
                            return graphique.series[graphique.series.length - 1];
                        } else {
                            return graphique.series[distance - 1];
                        }
                    } else {
                        return null;
                    }
            }
            break;
        case 'ValeurAxe': {
            let indiceValeur = graphique.axePrincipal.valeurs.indexOf(cellule);
            switch (direction) {
                case 'haut':
                    return null;
                case 'gauche':
                    if (distance === -1 || indiceValeur - distance < 0) {
                        return graphique.axePrincipal;
                    } else {
                        return graphique.axePrincipal.valeurs[indiceValeur - distance];
                    }
                case 'droite':
                    if (distance === -1 || indiceValeur + distance >= graphique.axePrincipal.valeurs.length) {
                        return graphique.axePrincipal.valeurs[graphique.axePrincipal.valeurs.length - 1];
                    } else {
                        return graphique.axePrincipal.valeurs[indiceValeur + distance];
                    }
                case 'bas':
                    if (graphique.series.length > 0) {
                        if (distance === -1 || distance - 1 >= graphique.series.length) {
                            return graphique.series[graphique.series.length - 1].valeurs[indiceValeur];
                        } else {
                            return graphique.series[distance - 1].valeurs[indiceValeur];
                            }
                    } else {
                        return null;
                    }
            }
            break;
        }
        case 'SerieGraphique':
            let serie = cellule;
            let indiceSerie = graphique.series.indexOf(serie);
            switch (direction) {
                case 'haut':
                    if (distance === -1 || indiceSerie - distance < 0) {
                        return graphique.axePrincipal;
                    } else {
                        return graphique.series[indiceSerie - distance];
                    }
                case 'gauche':
                    return null;
                case 'droite':
                    if (serie.valeurs.length > 0) {
                        if (distance === -1 || distance - 1 >= serie.valeurs.length) {
                            return serie.valeurs[serie.valeurs.length - 1];
                        } else {
                            return serie.valeurs[distance - 1];
                        }
                    } else {
                        return null;
                    }
                case 'bas':
                    if (distance === -1 || indiceSerie + distance >= graphique.series.length) {
                        return graphique.series[graphique.series.length - 1];
                    } else {
                        return graphique.series[indiceSerie + distance];
                    }
            }
            break;
        case 'ValeurSerie': {
            let indiceSerie = cellule.indiceSerie;
            let serie = graphique.series[indiceSerie];
            let indiceValeur = serie.valeurs.indexOf(cellule);
            switch (direction) {
                case 'haut':
                    if (distance === -1 || indiceSerie - distance < 0) {
                        return graphique.axePrincipal.valeurs[indiceValeur];
                    } else {
                        return graphique.series[indiceSerie - distance].valeurs[indiceValeur];
                    }
                case 'gauche':
                    if (distance === -1 || indiceValeur - distance < 0) {
                        return graphique.series[indiceSerie];
                    } else {
                        return serie.valeurs[indiceValeur - distance];
                    }
                case 'droite':
                    if (distance === -1 || indiceValeur + distance >= serie.valeurs.length) {
                        return serie.valeurs[serie.valeurs.length - 1];
                    } else {
                        return serie.valeurs[indiceValeur + distance];
                    }
                case 'bas':
                    if (distance === -1 || indiceSerie + distance >= graphique.series.length) {
                        return graphique.series[graphique.series.length - 1].valeurs[indiceValeur];
                    } else {
                        return graphique.series[indiceSerie + distance].valeurs[indiceValeur];
                    }
            }
            break;
        }
    }
}

export function getElement(positionSection, positionDansSection, rapport) {
    const section = getSection(positionSection, rapport.sectionPrincipale);
    if (!section) {
        return null;
    }
    if (positionDansSection.length > 0) {
        if (positionDansSection.length === 1) {
            if (positionDansSection[0] === -1) {
                return section.titre;
            } else {
                return section.elements[positionDansSection[0]];
            }
        } else {
            return trouverSousElement(section.elements[positionDansSection[0]], positionDansSection.slice(1), rapport);
        }
    } else {
        return section;
    }
}

export function getSection(positionSection, section) {
    if (positionSection.length > 0) {
        return getSection(positionSection.slice(1), section.sousSections[positionSection[0]]);
    } else {
        return section;
    }
}

export function getElementEtParent(positionSection, positionDansSection, rapport) {
    return {
        element: getElement(positionSection, positionDansSection, rapport),
        parent: getElement(positionSection, positionDansSection.slice(0, positionDansSection.length - 1), rapport)
    };
}

function trouverSousElement(elementParent, position, rapport) {
    if (position.length == 0) {
		return elementParent;
    } else if (position.length == 1) {
        if (elementParent.elements?.length > 0) {
            return elementParent.elements[position[0]];
        } else {
            return elementParent;
        }
	} else {
        if (elementParent.type === 'TABLEAU') {
            return elementParent.cellules.find(c => c.ligne == position[0] && c.colonne == position[1]);
        } else if (elementParent.type === 'GRAPHIQUE') {
            if (position[0] === 0) {
                // Sur l'axe
                if (position[1] === 0) {
                    return elementParent.axePrincipal;
                } else {
                    return elementParent.axePrincipal.valeurs[position[1] - 1];
                }
            } else {
                // Sur une série
                if (position[1] === 0) {
                    return elementParent.series[position[0] - 1];
                } else {
                    return elementParent.series[position[0] - 1].valeurs[position[1] - 1];
                }
            }
        } else {
            const element = elementParent.elements[position[0]];
            return trouverSousElement(element, position.slice(1), rapport);
        }
	}
}

export function trouverElementParent(elementEtParent, rapport) {
    const positionSection = elementEtParent.parent.positionSection;
    const positionParent = elementEtParent.parent.positionDansSection;
    if (positionParent.length > 1) {
	    const parent = getElement(positionSection, positionParent.slice(0, positionParent.length - 1), rapport);
        return {element: elementEtParent.parent, parent: parent};
    } else if (positionParent.length === 1) {
        return {element: elementEtParent.parent, parent: getSection(positionSection, rapport.sectionPrincipale)};
    } else {
        const positionSectionParente = positionSection.slice();
        positionSectionParente.pop();
        return {element: elementEtParent.parent, parent: getSection(positionSectionParente, rapport.sectionPrincipale)};
    }
}

export function trouverCelluleTableau(tableau, coordCellule) {
    if (coordCellule.ligne < 1) {
        coordCellule.ligne = 1;
    } else if (coordCellule.ligne > tableau.nbLignes) {
        coordCellule.ligne = tableau.nbLignes;
    } 
    if (coordCellule.colonne < 1) {
        coordCellule.colonne = 1;
    } else if (coordCellule.colonne > tableau.nbColonnes) {
        coordCellule.colonne = tableau.nbColonnes;
    } 
    return tableau.cellules.find(c => 
        (c.ligne <= coordCellule.ligne && c.ligne + c.hauteur > coordCellule.ligne
        && c.colonne <= coordCellule.colonne && c.colonne + c.largeur > coordCellule.colonne));
}

function getDirectionOpposee(direction) {
    switch(direction) {
        case 'haut':
            return 'bas';
        case 'droite':
            return 'gauche';
        case 'bas':
            return 'haut';
        case 'gauche':
            return 'droite';
    }
}

